import { useParams } from 'react-router-dom';

/**
 * Reads and validates the `:id` route param used by every restaurant-scoped
 * page. Returns `null` for a missing/non-numeric/non-positive value instead
 * of silently falling back to 0 or NaN, so the caller can render a clear
 * "restaurant not found" state instead of firing queries against a bogus id.
 */
export function useRestaurantId(): number | null {
  const { id } = useParams<{ id: string }>();
  const restaurantId = Number(id);
  return Number.isFinite(restaurantId) && restaurantId > 0 ? restaurantId : null;
}
